import { ProvidersPage } from '@Pages/Providers';

export const ProvidersRoute: React.FC = () => {
  return <ProvidersPage />;
};
